import { useState } from "react";
import DateTimePicker from "../../../../components/controls/DateTimePicker";
import { PlusIcon, TrashIcon } from "@heroicons/react/24/outline";
import { formatDateTime } from "../../../../globalFunctions/DateTimeDisplayCleaner";
import Button from "../../../../components/controls/Button";
export default function AvailabilityExceptionsSection({
  exceptions,
  loading,
  onAddException,
  onUpdateException,
  onDeleteException,
}) {
  const [collapsed, setCollapsed] = useState({});

  const toggle = (id) => {
    setCollapsed((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  if (loading) {
    return (
      <div className="text-center py-8">
        <div className="loading loading-spinner loading-lg"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h3 className="text-xl font-semibold">
          Exceptions (périodes d'indisponibilité)
        </h3>
        <Button
          onClick={onAddException}
          rightIcon={<PlusIcon className="w-4 h-4" />}
          size="sm"
        >
          Ajouter une exception
        </Button>
      </div>

      {exceptions.length === 0 && (
        <div className="text-gray-500 italic">Aucune période exclue.</div>
      )}

      {exceptions.map((ex, index) => (
        <div key={ex.id} className="border border-red-300 bg-red-50 rounded-xl">
          {/* HEADER COLLAPSABLE */}
          <div
            className={`flex items-center justify-between cursor-pointer select-none p-4 ${
              !collapsed[ex.id] ? "border-b" : ""
            }`}
            onClick={() => toggle(ex.id)}
          >
            <h4 className="font-bold text-md text-red-600 flex flex-col leading-tight">
              <span>{formatDateTime(ex?.startDateTime)}</span>

              <span className="text-sm text-red-500/80">
                {ex?.endDateTime
                  ? `au ${formatDateTime(ex.endDateTime)}`
                  : " Aucune fin définie"}
              </span>
            </h4>

            {/* Flèche */}
            <svg
              className={`w-5 h-5 transition-transform duration-200 ${
                !collapsed[ex.id] ? "rotate-180" : ""
              }`}
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M19 9l-7 7-7-7"
              />
            </svg>
          </div>

          {/* SI EXPAND → AFFICHER LE CONTENU */}
          {!collapsed[ex.id] && (
            <div className="p-4 space-y-4">
              {/* DELETE BUTTON */}
              <div className="flex justify-end">
                <Button
                  as="delete"
                  size="xs"
                  onClick={() => onDeleteException(index, ex.id)}
                  rightIcon={<TrashIcon className="w-4 h-4" />}
                >
                  Supprimer
                </Button>
              </div>

              {/* START DATETIME */}
              <DateTimePicker
                label="Début"
                value={ex.startDateTime ? new Date(ex.startDateTime) : null}
                onChange={(date) =>
                  onUpdateException(index, "startDateTime", date)
                }
              />

              {/* END DATETIME */}
              <DateTimePicker
                label="Fin"
                value={ex.endDateTime ? new Date(ex.endDateTime) : null}
                onChange={(date) =>
                  onUpdateException(index, "endDateTime", date)
                }
              />

              {/* Reason */}
              <div>
                <label className="label-text font-medium mb-1 block">
                  Raison
                </label>
                <input
                  type="text"
                  className="input input-bordered w-full"
                  placeholder="Raison interne (optionnel)"
                  value={ex.reason || ""}
                  onChange={(e) =>
                    onUpdateException(index, "reason", e.target.value)
                  }
                />
              </div>
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
